import moment from "moment";

// Configuración compartida de la pantalla de pedidos V2: estados, pestañas, permisos y formatos.

export const COLOR_MARCA = "#2471A3";

// Estados de pedido (tabla desplegables, modulo = 'pedidos')
export const ESTADOS = {
  19: { nombre: "Pendiente", color: "#B9770E", fondo: "#FDEBD0" },
  20: { nombre: "Revisado", color: "#7D6608", fondo: "#FCF3CF" },
  21: { nombre: "Aprobado", color: "#1E8449", fondo: "#D5F5E3" },
  22: { nombre: "Rechazado", color: "#922B21", fondo: "#F5B7B1" },
  23: { nombre: "Asignado", color: "#1F618D", fondo: "#D6EAF8" },
  24: { nombre: "Entregado", color: "#0E6655", fondo: "#D0ECE7" },
  25: { nombre: "Facturado", color: "#6C3483", fondo: "#E8DAEF" },
  32: { nombre: "Cancelado", color: "#566573", fondo: "#E5E7E9" },
  40: { nombre: "A facturar", color: "#2E4053", fondo: "#D6DBDF" },
  41: { nombre: "Sin entregar", color: "#78281F", fondo: "#FADBD8" },
  243: { nombre: "Error de facturación", color: "#B03A2E", fondo: "#F9D6D5" },
  244: { nombre: "Datos para facturar incompletos", color: "#A04000", fondo: "#FAE5D3" },
  248: { nombre: "Facturación especial", color: "#283593", fondo: "#E8EAF6" },
  263: { nombre: "Facturado pendiente de pago", color: "#5B2C6F", fondo: "#EBDEF0" },
  301: { nombre: "Informado a AFIP", color: "#4A235A", fondo: "#F4ECF7" },
  337: { nombre: "Refacturar", color: "#943126", fondo: "#FDEDEC" },
};

export const datosEstado = (idEstado, valor) =>
  ESTADOS[idEstado] || { nombre: valor || `Estado ${idEstado}`, color: "#424949", fondo: "#EAEDED" };

// Grupos de estados usados por pestañas y acciones
export const ESTADOS_A_FACTURAR = [40, 243, 244, 248];
export const ESTADOS_FACTURADOS = [25, 263];
export const ESTADOS_CON_ERROR_FACTURACION = [243, 244];
export const ESTADOS_CON_ENTREGA = [...ESTADOS_A_FACTURAR, ...ESTADOS_FACTURADOS];
export const ESTADOS_EN_CURSO = [19, 21, 23];

// Rango de fechas de registro (YYYY-MM-DD, ambos inclusivos). Por defecto: del 1° del mes a hoy.
export const rangoPorDefecto = () => ({
  desde: moment().startOf("month").format("YYYY-MM-DD"),
  hasta: moment().format("YYYY-MM-DD"),
});

export const rangoValido = (rango) => !!rango?.desde && !!rango?.hasta && rango.desde <= rango.hasta;

const conRango = (ruta, rango) => `${ruta}?desde=${rango.desde}&hasta=${rango.hasta}`;

// Fuentes de datos (backend: routes/granel, /api/granel_pedidos; copias de los endpoints de la V1),
// filtradas por fecha de registro
export const FUENTES = {
  // Todos los pedidos salvo cancelados, entregados, a facturar y facturados
  activos: (sucursales, rango) => conRango(`/granel_pedidos/activos/${sucursales}`, rango),
  aFacturar: (sucursales, rango) =>
    conRango(`/granel_pedidos/estado/${ESTADOS_A_FACTURAR.join(",")}/${sucursales}`, rango),
  facturados: (sucursales, rango) =>
    conRango(`/granel_pedidos/facturados/${sucursales}/${moment().format("YYYY-MM-DD")}`, rango),
};

// Pestañas. estados: filtro sobre la fuente (null = todos los de la fuente).
// conEntrega: muestra las columnas de entrega. soloComercial: habilitada para comerciales.
export const PESTANIAS = [
  { id: "todos", titulo: "Todos", fuente: "activos", estados: null },
  { id: "pendientes", titulo: "Por aprobar", fuente: "activos", estados: [19], comercial: true },
  { id: "aprobados", titulo: "Por asignar", fuente: "activos", estados: [21] },
  { id: "asignados", titulo: "Asignados", fuente: "activos", estados: [23] },
  { id: "aFacturar", titulo: "A facturar", fuente: "aFacturar", estados: null, conEntrega: true, comercial: true },
  { id: "facturados", titulo: "Facturados", fuente: "facturados", estados: null, conEntrega: true, facturados: true },
];

export const pestaniaPorId = (id) => PESTANIAS.find((p) => p.id === id) || PESTANIAS[0];

// Permisos (mismas reglas que la V1)
export const obtenerPermisos = () => {
  const sector = parseInt(localStorage.getItem("sector"));
  return {
    // Comercial de granel: rol usuario y sector 13
    esComercial: localStorage.getItem("role") === "usuario" && sector === 13,
    // Editar, cancelar, registrar visita y marcar aprobado: sector 12
    esGranel: sector === 12,
  };
};

// Formatos
export const formatearFecha = (fecha) =>
  fecha && moment(fecha).isValid() ? moment(fecha).format("DD-MM-YYYY") : null;

export const formatearNumero = (valor) =>
  valor === null || valor === undefined || valor === ""
    ? null
    : Number(valor).toLocaleString("es-AR", { maximumFractionDigits: 2 });

// Cantidad entregada: kg o litros, según lo que se haya registrado
export const cantidadEntregada = (pedido) => {
  if (pedido.kgentregados) return `${formatearNumero(pedido.kgentregados)} kg`;
  if (pedido.ltsentregados) return `${formatearNumero(pedido.ltsentregados)} lts`;
  return null;
};

// Pedido en curso con la fecha requerida ya pasada
export const estaVencido = (pedido) =>
  ESTADOS_EN_CURSO.includes(pedido.id_estado) &&
  !!pedido.fecha_requerida &&
  moment(pedido.fecha_requerida).isBefore(moment(), "day");
